module.exports = __webpack_public_path__ + "static/media/mobile_info.7bee2345.jpg";